import client from './client';

export const getActivities = async (startDate, endDate) => {
    const response = await client.get('/activities/', {
        params: { start_date: startDate, end_date: endDate },
    });
    return response.data.activities;
};

export const getTotalPoints = async () => {
    const response = await client.get('/activities/stats/total-points');
    return response.data.total_points;
};

export const getActivityFeed = async (offset = 0, limit = 10) => {
    const response = await client.get('/activities/feed', { params: { offset, limit } });
    return response.data;
};

/**
 * Log an activity scored with sp_v1_0.
 *
 * @param {Object} payload
 * @param {string} payload.activity_id
 * @param {string|null} [payload.primary_answer_code]
 * @param {string|null} [payload.secondary_answer_code]
 * @param {number} payload.duration_seconds
 * @param {number} payload.personal_effort  whole number 1-10
 * @param {string} [payload.date]  YYYY-MM-DD
 */
export const logActivity = async (payload) => {
    const response = await client.post('/activities/activity', payload);
    return response.data;
};

/**
 * All scorable activities from the Reference MET catalog:
 * [{ activity_id, activity_name, activity_description, search_terms }]
 */
export const getActivityList = async () => {
    const response = await client.get('/activities/config/list');
    return response.data;
};

/**
 * Questions, answer options, and supported answer combinations for one activity:
 * { activity, primary_question|null, secondary_question|null, combinations }
 */
export const getActivityCatalog = async (activityId) => {
    const response = await client.get(`/activities/catalog/${encodeURIComponent(activityId)}`);
    return response.data;
};

export const getFrequentActivities = async () => {
    try {
        const response = await client.get('/activities/config/frequent');
        return response.data;
    } catch (error) {
        return [];
    }
};

export const getActivityById = async (activityId) => {
    const response = await client.get('/activities/activity', {
        params: { activity_id: activityId },
    });
    return response.data.activity;
};

/**
 * "Same effort": { sp, input_activity, conversions: [{ activity_id, activity_name, minutes, reference_met, answers }] }
 */
export const getEquivalentActivities = async (sp, activity) => {
    const response = await client.get('/activities/convert-sp', { params: { sp, activity } });
    return response.data;
};

export const deleteActivity = async (activityId) => {
    const response = await client.delete('/activities/activity', {
        params: { activity_id: activityId },
    });
    return response.data;
};
